import {Component, inject, Input, OnInit} from '@angular/core';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {PlayerProfile} from '../../../../model/player-profile';
import {Button} from 'primeng/button';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {
  PlayerProfileAddLinksDialogComponent
} from './player-profile-add-links-dialog/player-profile-add-links-dialog.component';
import {DialogService} from 'primeng/dynamicdialog';
import {InputBoxResult} from '../../../../../shared/common/input-box/input-box.component';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {ErrorType} from '../../../../../../model/error-type';
import {Divider} from 'primeng/divider';
import {MessageComponent} from '../../../../../../components/generic/message/message.component';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {environment} from '../../../../../../../environments/environment';
import {GenericListComponent} from '../../../../../../components/generic/generic-list/generic-list.component';
import {ColumnType} from '../../../../../../components/generic/generic-list/columnType';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-player-profile-account-links',
  standalone: true,
  imports: [
    InfoTextComponent,
    Button,
    TranslatePipe,
    Divider,
    MessageComponent,
    LoadingComponent,
    GenericListComponent,
    PrimeTemplate,
    RouterLink
  ],
  templateUrl: './player-profile-account-links.component.html',
  styleUrl: './player-profile-account-links.component.scss'
})
export class PlayerProfileAccountLinksComponent implements OnInit
{
  @Input() playerProfile: PlayerProfile;

  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);
  private confirmationService = inject(ConfirmationService);

  isLoading: boolean;
  listLoading: boolean;
  errorMsg: ErrorType;
  columns: any[];
  columnsMobile: ColumnType[];

  linkedPlayers: any[];

  ngOnInit(): void
  {
    this.initColumns();
    this.loadData();
  }

  private initColumns(): void
  {
    this.columns = [
      { header: 'PLAYER', field: 'playerName', datatype: '', width: '', filterType: 'text', sortable: true },
      { header: 'ASSOCIATION', field: 'mandantName', datatype: '', width: '200', filterType: 'text', sortable: true, class: 'text-center' },
      { header: 'MEMBER_NR', field: 'passNr', datatype: '', width: '170', filterType: 'text', sortable: true, class: 'text-center' },
    ];

    this.columnsMobile = [
      {
        key: 'MAT',
        header: 'LINKED_PLAYERS'
      }
    ];
  }

  private loadData(): void
  {
    this.isLoading = true;
    this.playerProfileService.getLinkedLeaguePlayers().subscribe({
      next: data =>
      {
        console.log('Spieler-Verlinkungen erhalten', data);
        this.linkedPlayers = data;
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public linkAccount(): void
  {
    if (!this.playerProfile?.birthday || !this.playerProfile?.firstname || !this.playerProfile?.lastname)
    {
      this.restErrorHelper.showInfoMessageService('LINK_PLAYER_BIRTHDAY_MUST_BE_GIVEN',
        environment.toastDurationShort);
      return;
    }

    const ref = PlayerProfileAddLinksDialogComponent.openDialog(this.dialogService,
      this.playerProfile, this.translate);
    ref.onClose.subscribe((result: InputBoxResult) =>
    {
      console.log('result: ', result);
      if (result)
        this.loadData();
    });
  }

  public deleteLinkedPlayer(item: any): void
  {
    console.log('deleteLinkedPlayer: ', item);

    this.confirmationService.confirm({
      message: this.translate.instant('PLAYER_PROFILE_DELETE_LINKED_PLAYER_MSG', {value: item.playerName}),
      header: this.translate.instant('MSG_HEADER_DELETE_ENTRY'),
      icon: 'pi pi-question-circle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      rejectButtonStyleClass: 'button-no button-right',
      accept: () =>
      {
        this.listLoading = true;
        this.playerProfileService.deletePlayerIdentification(item).subscribe({
          next: data =>
          {
            console.log('Spielerverbindung gelöscht', data);
            this.listLoading = false;
            this.loadData();
          },
          error: error =>
          {
            this.listLoading = false;
            this.restErrorHelper.handleErrorService(error);
          }
        });
      }
    });
  }
}
